import { observer } from 'mobx-react-lite'
import { type Section7216AcceptancesListViewModel } from '@/features/account/section-7216/Section7216AcceptancesList/Section7216AcceptancesListViewModel'
import { dateFormatters } from '@/utils/date-util'
import { useScopedViewModel } from '@/hooks/view-model-hooks'
import { ViewAcceptedSection7216DialogViewModel } from '@/features/account/section-7216/ViewAcceptedSection7216Dialog/ViewAcceptedSection7216DialogViewModel'
import { ViewAcceptedSection7216DialogContainer } from '@/features/account/section-7216/ViewAcceptedSection7216Dialog/ViewAcceptedSection7216DialogContainer'
import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateIconDecoration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { AcceptanceListContainer } from '@/features/account/components/AcceptanceList/AcceptanceListContainer'
import { AcceptanceListItem } from '@/features/account/components/AcceptanceList'

export interface Section7216AcceptancesListContainerProps {
  vm: Section7216AcceptancesListViewModel
  'aria-labelledby': string
}

export const Section7216AcceptancesListContainer = observer(
  function Section7216AcceptancesListContainer({
    vm,
    ...rest
  }: Section7216AcceptancesListContainerProps) {
    const viewVm = useScopedViewModel(({ account }, needs) => {
      const { internal } = needs({ internal: account.internal() })
      return new ViewAcceptedSection7216DialogViewModel(
        internal.section7216Store,
      )
    })

    return (
      <>
        <AcceptanceListContainer
          {...rest}
          scroller={vm.scroller}
          renderEmptyState={() => <EmptyAgreements />}
        >
          {(item) => (
            <AcceptanceListItem
              key={item.id}
              title="Data disclosure acceptance"
              subtitle={`Accepted ${dateFormatters.dateLong.format(item.createdAt)}`}
              textValue={`Section 7216 accepted ${dateFormatters.dateLong.format(item.createdAt)}`}
              onAction={() =>
                viewVm.view(
                  item.section7216Id,
                  item.userSignature,
                  item.spouseSignature,
                  item.createdAt,
                )
              }
            />
          )}
        </AcceptanceListContainer>
        <ViewAcceptedSection7216DialogContainer vm={viewVm} />
      </>
    )
  },
)

function EmptyAgreements() {
  return (
    <EmptyState>
      <EmptyStateIconDecoration icon="file" />
      <EmptyStateTitle>No authorizations</EmptyStateTitle>
      <EmptyStateDescription>
        Once you've authorized the data disclosure agreement, the acceptance
        record will appear here.
      </EmptyStateDescription>
    </EmptyState>
  )
}
